import { create } from "zustand";
import { OpenToastParams, ToastItem } from "@/types/toast";

const genRandomId = () => Math.random().toString(32).substring(2);

export type ToastType = {
	toasts: ToastItem[];
	openToast: (params: OpenToastParams) => void;
	closeToast: (id: string) => void;
};

export const toastStore = create<ToastType>((set) => ({
	toasts: [],
	openToast: (params) => {
		const id = genRandomId();
		set((state) => ({
			toasts: [...state.toasts, { id, isOpen: true, ...params }],
		}));
	},
	closeToast: (id) => {
		set((state) => ({
			toasts: state.toasts.map((toast) =>
				toast.id === id ? { ...toast, isOpen: false } : toast,
			),
		}));
		setTimeout(() => {
			set((state) => ({
				toasts: state.toasts.filter((toast) => toast.id !== id),
			}));
		}, 200);
	},
}));
